import React from "react";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import Loadable from "react-loadable";
import Loader from "../components/loader";

/**
 * Constants for page title and description
 */
export const siteTitle = "Taxida";
export const siteMetaDescription =
  "Taxida offers a hassle-free, reliable and affordable taxi cab service to travel within city or outstation across India.";

/**
 * Function is to set Title for each page
 * @param {*} title
 */
export const setTitle = title => {
  document.title = title ? title : siteTitle;
};

/**
 * Function is to set page description
 * @param {*} description
 */
export const setMetaDescription = description => {
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", description ? description : siteMetaDescription);
};

/**
 * List of routes for the page
 */
export const ROUTE = {
  public: [
    {
      exact: true,
      path: "/",
      meta: {},
      name: "Home", // for breadcrumbs
      component: Loadable({
        loader: () => import("../containers/login"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/login",
      meta: {},
      component: Loadable({
        loader: () => import("../containers/login"),
        loading: Loader
      })
    }
  ],
  private: [
    {
      exact: true,
      path: "/booking/add",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/bookings/index"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/booking/add/:id",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/bookings/index"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/triplist/pending",
      meta: {},
      name: "Pending",
      component: Loadable({
        loader: () => import("../containers/tripList/PendingList"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/triplist/inprogress",
      meta: {},
      name: "Inprogress",
      component: Loadable({
        loader: () => import("../containers/tripList/InprogressList"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/triplist/completed",
      meta: {},
      name: "Completed",
      component: Loadable({
        loader: () => import("../containers/tripList/CompletedList"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/ets-triplist/inprogress",
      meta: {},
      name: "Inprogress ets",
      component: Loadable({
        loader: () => import("../containers/tripListEts/InprogressEts"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/ets-triplist/closed",
      meta: {},
      name: "Closed ets",
      component: Loadable({
        loader: () => import("../containers/tripListEts/CompletedEts"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/reports/general",
      meta: {},
      name: "Complete",
      component: Loadable({
        loader: () => import("../containers/reports/Completed"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/driver-tracking/:id",
      meta: {},
      name: "Driver tracking",
      component: Loadable({
        loader: () => import("../containers/triplistDetail/DriverTracking"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/direction-tracking/:bookingId",
      meta: {},
      name: "Driver tracking",
      component: Loadable({
        loader: () => import("../containers/triplistDetail/newDirection"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/reports/shuttle",
      meta: {},
      name: "Active",
      component: Loadable({
        loader: () => import("../containers/reports/active"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/triplist/view/:id",
      meta: {},
      name: "Inprogress",
      component: Loadable({
        loader: () => import("../containers/triplistDetail/CorpDetails"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/triplist/ets-view/:id",
      meta: {},
      name: "Ets details",
      component: Loadable({
        loader: () => import("../containers/triplistDetail/EtsDetails"),
        loading: Loader
      })
    },
    // {
    //   exact: true,
    //   path: "/users/admin",
    //   meta: {},
    //   name: "Admin",
    //   component: Loadable({
    //     loader: () => import("../containers/users/Admin/adminList"),
    //     loading: Loader
    //   })
    // },
    {
      exact: true,
      path: "/users/employee",
      meta: {},
      name: "Employee",
      component: Loadable({
        loader: () => import("../containers/users/Admin/employee"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/users/employee/:id",
      meta: {},
      name: "Employee details",
      component: Loadable({
        loader: () => import("../containers/triplistDetail/EmployeeDetails"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/tripsheet/shuttle",
      meta: {},
      name: "Tripsheet",
      component: Loadable({
        loader: () => import("../containers/tripSheet"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/tripsheet/general",
      meta: {},
      name: "Tripsheet",
      component: Loadable({
        loader: () => import("../containers/tripSheet/general"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/api-document",
      meta: {},
      name: "Api document",
      component: Loadable({
        loader: () => import("../containers/apiDocument"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/api-document/detail/:id",
      meta: {},
      name: "Api document detail",
      component: Loadable({
        loader: () => import("../containers/apiDocument/ApiDetail"),
        loading: Loader
      })
    },
    {
      exact: true,
      path: "/under-construction",
      meta: {},
      name: "Under construction",
      component: Loadable({
        loader: () => import("../containers/UnderConstruction"),
        loading: Loader
      })
    },
    {
      path: "*",
      exact: false,
      meta: {},
      name: "Page Not Found",
      component: Loadable({
        loader: () => import("../containers/pageNotFound/index"),
        loading: Loader
      })
    }
  ]
};

/**
 * Function to set route info
 * @param {routeName} routeName
 */
export const setRoutes = routeName => {
  routeName = routeName || "public";
  const route = ROUTE[routeName];
  return route.map((eachRoute, index) => {
    if (routeName === "private") {
      return <PrivateRoute key={index} {...eachRoute} />;
    } else {
      return <PublicRoute key={index} {...eachRoute} />;
    }
  });
};
